/**
 * Created by ori on 20/09/16.
 */
export default () => ({
    email: '',
    password: '',
    confirmPassword: '',
});


// WEBPACK FOOTER //
// ./src/js/store/Signup.js